export default __webpack_public_path__ + "static/banner-csm-f869a9455252e5420f490bf307afd5e8.webp";